<script>
    import ArtistCol from "./ArtistCol";

    export default {
        name: "FeaturedArtists",
        components: {ArtistCol},
        props: {
            data: {
                type: Object,
                required: true
            },
            noSlide: {
                type: Boolean
            },
            titleClass: {
                type: String,
                default: ""
            },
            slidePerPage: {
                type: Number,
                default: 4
            },
            slidePerPageTablet: {
                type: Number,
                default: 2
            },
            slidePerPageMobile: {
                type: Number,
                default: 2
            }
        },
        emits: ["artist-clicked"],
        data() {
            return {
                sliderOptions: {
                    perPage: this.slidePerPage,
                    breakpoints: {
                        991: {
                            perPage: this.slidePerPageTablet,
                        },
                        787: {
                            perPage: this.slidePerPageMobile,
                        }
                    }
                }
            };
        }
    };
</script>

<template>
    <div class="featuredArtistsSection @relative">
        <h2 class="@mb-8 desktop:@mb-10 @container @text-center" :class="titleClass" v-html="data.title"/>
        <div class="slider @static @container">
            <Slider
                v-if="!noSlide"
                :options="sliderOptions"
                :arrow-next-style="{top: '130px'}"
                :arrow-prev-style="{top: '130px'}"
            >
                <SplideSlide v-for="(artist, index) in data.list" :key="index" class="slide tablet-lg:@mb-0">
                    <ArtistCol class="@px-2.5 tablet:@px-4 @mb-0" :artist="artist" @artist-clicked="$emit('artist-clicked', artist, +index)"/>
                </SplideSlide>
            </Slider>
            <!--     NoSlider       -->
            <div v-else class="tablet-lg:@flex @justify-center @gap-x-5 tablet:@gap-x-8 @mb-0">
                <div v-for="(artist, index) in data.list" :key="index" class="@mb-8">
                    <ArtistCol :artist="artist" @artist-clicked="$emit('artist-clicked', artist, +index)"/>
                </div>
            </div>
        </div>
        <div v-if="data.see_all_link_text" class="@text-center @mt-4 tablet-lg:@mt-12">
            <a class="mkButton beige" :href="data.see_all_link_url">{{data.see_all_link_text}}</a>
        </div>
    </div>
</template>
